import {
	CONSIGNMENT_BRANCH_SETTING_ACTION,
	CONSIGNMENT_BRANCH_SETTING_TAB,
} from "@/core/helpers/consignmentBranchSettingTab";
import { ConsignmentBranchSettingListPage } from "@/features/consignment-branch-setting/pages/ConsignmentBranchSettingListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Unknown tab falls back.
const SELECTABLE_BRANCH_SETTING_TABS: string[] = Object.values(
	CONSIGNMENT_BRANCH_SETTING_TAB,
);

const SELECTABLE_BRANCH_SETTING_ACTIONS: string[] = Object.values(
	CONSIGNMENT_BRANCH_SETTING_ACTION,
);

export const Route = createFileRoute("/admin/consignment-branch-setting/")({
	validateSearch: (
		search: Record<string, unknown>,
	): { tab?: string; action?: string } => ({
		tab: SELECTABLE_BRANCH_SETTING_TABS.find(
			(branchSettingTab) => branchSettingTab === search.tab,
		),
		action: SELECTABLE_BRANCH_SETTING_ACTIONS.find(
			(branchSettingAction) => branchSettingAction === search.action,
		),
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: {
					operator: "OR",
					permissions: [
						"consignment_store_setting.view",
						"consignment_region.manage",
						"consignment_team.manage",
						"consignment_pilot_invite.view",
					],
				},
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentBranchSettingListPage,
});
